import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class FileGalleryRoute extends Route {
  @service store;

  @breadcrumb crumb = 'File Gallery';

  model(params) {
    return hash({
      fileGallery: this.store.findRecord('file-gallery', params.file_gallery_id, {
        include: 'field_file',
      })
    });
  }

  @breadcrumbResolve modelCrumbResolve(model) {
    return model.fileGallery;
  }
  @breadcrumbResolved modelCrumb(model) {
    return [ this.crumb, model.fileGallery.get('title') ];
  }
}
